import styled, { css } from 'styled-components'
import { Orientation } from './types'
import { OVERLAYS_Z_INDEX } from './constants'

export const Container = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

type ArtboardBoundsContainerProps = {
  x: number
  y: number
  width: number
  height: number
}
export const ArtboardBoundsContainer = styled.div<ArtboardBoundsContainerProps>`
  position: absolute;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  left: ${({ x }) => x}px;
  top: ${({ y }) => y}px;
`

export const LayerOverlay = styled.div<{
  $width: number
  $height: number
  $x: number
  $y: number
  $borderSize: number
  $color: 'red' | 'blue' | 'purple'
  $zIndex?: number
}>`
  position: absolute;
  ${({ $x, $y, $width, $height, $borderSize, $color, theme }) => {
    let color = ''
    if ($color === 'red') {
      color = 'red'
    } else if ($color === 'blue') {
      color = 'rgb(5, 143, 255)'
    } else if ($color === 'purple') {
      color = theme.colors.inspect.symbol.A
    }

    return css`
      transform: translate(${$x}px, ${$y}px);
      width: ${$width}px;
      height: ${$height}px;
      border-width: ${$borderSize}px;
      border-color: ${color};
      border-style: solid;
    `
  }}

  ${({ $zIndex }) => $zIndex && `z-index: ${$zIndex};`}
`

export const SelectedLayerCorners = styled.div<{
  $width: number
  $height: number
  $x: number
  $y: number
}>`
  position: absolute;
  z-index: ${OVERLAYS_Z_INDEX.SELECTED_RECTANGLE_CORNERS};
  ${({ $x, $y, $width, $height }) => {
    return css`
      transform: translate(${$x}px, ${$y}px);
      width: ${$width}px;
      height: ${$height}px;
    `
  }}
`

export const SelectionGuidelines = styled.div<{
  $orientation: Orientation
  $x: number
  $y: number
  $width: number
  $height: number
}>`
  position: absolute;
  border: 1px dashed red;
  ${({ $orientation, $x, $width }) =>
    $orientation === Orientation.Vertical &&
    css`
      width: ${$width}px;
      height: calc(100% + 2px);
      transform: translate(${$x}px, 0px);
      top: -1px;
    `}
  ${({ $orientation, $y, $height }) =>
    $orientation === Orientation.Horizontal &&
    css`
      width: calc(100% + 2px);
      height: ${$height}px;
      transform: translate(0px, ${$y}px);
      left: -1px;
    `}
`

export const MeasurementLine = styled.div<{
  $orientation: Orientation
  $x: number
  $y: number
  $lineSize: number
}>`
  z-index: ${OVERLAYS_Z_INDEX.MEASUREMENT_LINE};
  position: absolute;
  background: rgb(5, 143, 255);
  display: flex;
  align-items: center;
  justify-content: center;
  transform: ${({ $x, $y }) => `translate(${$x}px, ${$y}px)`};
  width: ${({ $orientation, $lineSize }) =>
    $orientation === Orientation.Horizontal ? `${$lineSize}px` : '1px'};
  height: ${({ $orientation, $lineSize }) =>
    $orientation === Orientation.Horizontal ? '1px' : `${$lineSize}px`};
`

export const MeasurementPill = styled.div<{
  $orientation: Orientation
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  font-size: 10px; /* stylelint-disable-line */
  height: 12px;
  padding: 0 5px; /* stylelint-disable-line */
  border-radius: 6px;
  color: white;
  background: rgb(5, 143, 255);
  transform: ${({ $orientation }) =>
    $orientation === Orientation.Horizontal
      ? 'translateY(calc(-50% - 4px));'
      : 'translateX(calc(-50% - 4px));'};
`
